export const maxProducts = 1500;

// validate type format files (excel, text, csv, image/x-dds)
export const allowedRegex = /^(|application\/x-godot-resource|text\/plain|application\/vnd\.(ms-excel|openxmlformats-officedocument\.spreadsheetml\.sheet|ms-excel\.sheet\.binary\.macroEnabled\.12|ms-excel\.sheet\.macroEnabled\.12)|text\/csv|image\/x-dds|image\/vnd\.ms-dds|image\/dds)$/;

export const localPossibleError = 'NOT-ALLOWED-FORMAT'